import { useEffect, useState } from 'react'
import { typeVariant } from '../types';

type props = {
  variants: Array<typeVariant>
  options: string[]
  updateCurrentVariant: (variant: any) => void
  currentVariant: any
}

function useProductVariant ({ variants, options, updateCurrentVariant, currentVariant }: props) {
  const [selected, setSelected] = useState({})
  const [selectableValues, setSelectableValues] = useState({})

  const getSelectableValues = (availableValues: {[p: string]: string[]}, selected: {[p: string]: string}) => {
    const values = Object.assign({}, availableValues)
    const selectedOptions = Object.keys(selected)
    if (!selectedOptions.length) {
      return values
    }
    for (const selectedOption of selectedOptions) {
      const selectedValue = selected[selectedOption]
      const otherOptions = options.filter((option) => option !== selectedOption)
      if (otherOptions.length) {
        for (const otherOption of otherOptions) {
          values[otherOption] = values[otherOption].filter((value: string) => {
            return variants.some((variant) => variant.options.indexOf(value) !== -1 && variant.options.indexOf(selectedValue) !== -1 && variant.available)
          })
        }
      } else {
        values[selectedOption] = values[selectedOption].filter((value: string) => {
          if (options.length > 1) {
            return variants.some((variant) => variant.options.indexOf(value) !== -1 && variant.options.indexOf(selectedValue) !== -1 && variant.available)
          } else {
            return variants.some((variant) => variant.options.indexOf(selectedValue) !== -1 && variant.available)
          }
        })
      }
    }
    return values
  }

  const getSelectedVariant = (selectedValues: { [p: string]: string }) => {
    const matched = variants.filter((variant) => {
      const matchedOptions = []
      for (const option in selectedValues) {
        matchedOptions.push(variant.options.includes(selectedValues[option]))
      }
      return matchedOptions.reduce((result: boolean, item) => result && item, true)
    })

    return matched[0]
  }

  const getInitialSelected = (currentVariant: typeVariant) => {
    const values: {
      [key: string]: string | null
    } = {}
    for (const index in options) {
      const option = options[index]

      if (!values[option]) {
        values[option] = null
      }

      const value = currentVariant.options[index]
      if (values[option] !== value) {
        values[option] = value
      }
    }

    return values
  }

  const availableValues = (() => {
    const values: {
      [key: string]: string[]
    } = {}
    for (const index in options) {
      const option = options[index]

      if (!values[option]) {
        values[option] = []
      }

      for (const variant of variants) {
        const value = variant.options[index]
        if (!values[option].includes(value)) {
          values[option].push(value)
        }
      }
      
      if (option === 'Letter') {
        values[option] = values[option].sort((a, b) => a.localeCompare(b))
      }
    }
    return values
  })()

  useEffect(() => {
    const selectableOptions = getSelectableValues(availableValues, selected)
    if (selectableOptions) {
      setSelectableValues(selectableOptions)
    }
    const selectedVariant = getSelectedVariant(selected)
    if (selectedVariant) {
      updateCurrentVariant(selectedVariant)
      // globalEmitter.emit(emitterProps.product.updateVariant, selectedVariant)
    }
  }, [selected])

  useEffect(() => {
    const selectedInit = getInitialSelected(currentVariant)
    setSelected(selectedInit)
  }, [currentVariant, options])

  return {
    selected,
    setSelected,
    availableValues,
    selectableValues
  }
}

export default useProductVariant
